module.exports = __webpack_public_path__ + "images/confusion-gif-2.gif";